export default (axios, path = '/user') => ({
  findAll: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}`)
  },
  activate: async (id) => {
    return await axios.put(`${path}/activate/${id}`)
  },
  deactivate: async (id) => {
    return await axios.put(`${path}/deactivate/${id}`)
  },
  changeRole: async ({id, role}) => {
    return await axios.put(`${path}/role/${id}/${role}`)
  },
  findOne: async (id) => {
    return await axios.get(`${path}`, {id})
  },
  getAllUsers: async () => {
    return await axios.get(`${path}`)
  },
  findByEmail: async (email) => {
    return await axios.get(`${path}/search?email=` + email)
  },
  findByUsername: async (username) => {
    return await axios.get(`${path}/search?username=`+ username)
  },
  findByBoth: async (username) => {
    return await axios.get(`${path}/search?username=`+ username+`&email=`+username)
  },
  findAllArchivedGames: async () => {
    var x = await axios.get(`${path}/account/history?action=GAME_PLAYED&page=1&size=20`);
    var maximum = x.data.total - 30;
    var all = await axios.get(`${path}/account/history?action=GAME_PLAYED&page=1&size=`+maximum);
    return all;
    //return await axios.get(`${path}/account/history`)
  },
})
